import { render, staticRenderFns } from "./DesgloseMetodosPagoComponent.vue?vue&type=template&id=98813af2&scoped=true"
import script from "./DesgloseMetodosPagoComponent.vue?vue&type=script&lang=js"
export * from "./DesgloseMetodosPagoComponent.vue?vue&type=script&lang=js"
import style0 from "./DesgloseMetodosPagoComponent.vue?vue&type=style&index=0&id=98813af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98813af2",
  null
  
)

export default component.exports